import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class NonAuthGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    return this.checkNonAuth();
  }

  canActivateChild(_childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(_childRoute, state);
  }

  canMatch(_route: Route, _segments: UrlSegment[]): boolean {
    return this.checkNonAuth();
  }

  private checkNonAuth(): boolean {
    if (!this.authService.isAuthenticated()) {
      return true;
    }

    // Si el usuario ya está autenticado, lo redirige a la página principal
    this.router.navigate(['/']).then((r) => r);
    return false;
  }
}
